import React from 'react';
import debug from 'debug';
import jsonp from 'jsonp';
import Giphy from './Giphy';

export default class ContentManager {
    isInitialized = false;

    static init(response) {
        if (this.isInitialized) {
            return;
        }
        this.isInitialized = true;
        let redditGifApi = `https://akz.imgfarm.com/pub/feeds/giphy/redditgif.jsonp?v=${new Date().getTime()}`; // `https://akz.imgfarm.com/pub/feeds/y/redditgif.jsonp`; // Working `https://akz.imgfarm.com/pub/feeds/giphy/redditgif.jsonp?v=${new Date().getTime()}`;
        jsonp(redditGifApi, {
            name: 'jsonpCallback'
        }, (err, data) => {
            if (err) {
                throw(err);
                // Secondary API 
                // response(this.backupAPI(response));
            }
            response(data);
        });
    }

    // backupAPI(response) {
    //         // console.log(responseJson.toString());

    //     return fetch(`http://api.giphy.com/v1/gifs/trending.json?api_key=${`3o85xuOJWgARXirRsY`}&limit=50`)
    //         .then((response) => response.json())
    //         .then((responseJson) => {
    //             console.log(responseJson.toString());
    //             return responseJson;
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //     });
    // }
}